import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
// import Dashboard from './pages/Dashboard'; // Commented out - opens directly to Animals page
import Animals from './pages/Animals';
import Volunteers from './pages/Volunteers';
import Adoptions from './pages/Adoptions';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} /> */}
            <Route path="/" element={<ProtectedRoute><Animals /></ProtectedRoute>} />
            <Route path="/animals" element={<ProtectedRoute><Animals /></ProtectedRoute>} />
            <Route path="/volunteers" element={<ProtectedRoute><Volunteers /></ProtectedRoute>} />
            <Route path="/adoptions" element={<ProtectedRoute><Adoptions /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 